import { StateCreator } from "zustand";

export const WebDavCookieName = "use-webdav";

export interface IWebDavState {
    useWebDav: boolean;
}

export interface WebDavSlice {
    webDav: IWebDavState;
    setWebDav: (state: IWebDavState) => void;
    toggleWebDav: () => void;
}

const getInitialWebDavState = (): IWebDavState => ({
    useWebDav: document.cookie.includes(WebDavCookieName),
});

export const createWebDavSlice: StateCreator<WebDavSlice, [], [], WebDavSlice> = (set) => ({
    webDav: getInitialWebDavState(),

    setWebDav: (state) => set({ webDav: state }),

    toggleWebDav: () =>
        set((prev) => ({
            webDav: { useWebDav: !prev.webDav.useWebDav },
        })),
});
